var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIdentityFinder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00307,
    stopColor: "#56c5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38156,
    stopColor: "#5674ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#565def"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5623ee"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.66831,24.74347h-23.33662c-2.54503,0-4.6081,2.06313-4.6081,4.6081v41.29687c0,2.54497,2.06307,4.6081,4.6081,4.6081h23.33662c2.54497,0,4.6081-2.06313,4.6081-4.6081V29.35157c0-2.54497-2.06313-4.6081-4.6081-4.6081ZM63.24134,65.24825c0,.63635-.51582,1.15217-1.15217,1.15217h-24.17835c-.63635,0-1.15223-.51582-1.15223-1.15217V29.8936c0-.63629.51588-1.15217,1.15223-1.15217h24.17835c.63635,0,1.15217.51588,1.15217,1.15217v35.35465Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.8014,47.42213c-.19502-.24172-4.84201-5.92313-10.80175-5.92313-5.95911,0-10.6061,5.68141-10.80112,5.92313-.3812.47335-.3812,1.14865,0,1.622.19502.24172,4.84201,5.92313,10.80112,5.92313,5.95974,0,10.60673-5.68141,10.80175-5.92313.3812-.47335.3812-1.14865,0-1.622ZM48.81369,44.19407c-1.75382.51539-3.04251,2.11846-3.04251,4.03914,0,1.92028,1.28805,3.52311,3.0414,4.0389-3.02673-.50735-5.63471-2.79219-6.85854-4.03898,1.22399-1.24695,3.83244-3.53203,6.85965-4.03906ZM51.18736,52.27202c1.75327-.51579,3.04125-2.11854,3.04125-4.03882,0-1.9206-1.28853-3.52358-3.04235-4.03906,3.02744.50719,5.63573,2.79211,6.85965,4.03898-1.22376,1.24671-3.83157,3.53132-6.85854,4.0389Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIdentityFinder);
export default __webpack_public_path__ + "static/media/phone-identity-finder.5f3bb4799b96b22cb7a7e8a852744799.svg";
export { ForwardRef as ReactComponent };